import { Lock, LockOpen } from "@phosphor-icons/react";

export const LockTimer = ({ lock }) => {
  if (!lock) return null;
  if (lock.locked) {
    return (
      <span data-testid="lock-indicator-locked" className="inline-flex items-center gap-1.5 text-red-600 font-mono text-xs font-semibold bg-red-50 border border-red-200 px-2 py-1 rounded">
        <Lock size={13} weight="fill" /> LOCKED
      </span>
    );
  }
  if (lock.admin_unlocked) {
    return (
      <span data-testid="lock-indicator-open" className="inline-flex items-center gap-1.5 text-amber-700 font-mono text-xs font-semibold bg-amber-50 border border-amber-200 px-2 py-1 rounded">
        <LockOpen size={13} weight="fill" /> UNLOCKED BY ADMIN
      </span>
    );
  }
  return null;
};
